import React from 'react';
import PropTypes from 'prop-types';
import DetailsTableHeader from './details_table_header';
import DetailsTableBody from './details_table_body';
import { VIEW_MODES } from '../../constants';

const DetailsHoleTable = ({ className, data, viewMode, holeByHoleView, label, showYardage, onToggleYardage }) => {
  // The player's starting hole is marked on the Holes header row (Figma:
  // green cell around the hole number). start_hole is a display string
  // ("10"); Number('') and Number(null) are 0, so anything that doesn't
  // parse to a real hole leaves the marker off.
  const parsedStartHole = Number(data.startHole);
  const startHoleIndex = Number.isInteger(parsedStartHole) && parsedStartHole >= 1 ? parsedStartHole - 1 : null;

  return (
    <table className={className}>
      <DetailsTableHeader holeLabels={data.nets[0].tee.holeLabels} startHoleIndex={startHoleIndex} />
      <DetailsTableBody
        data={data}
        viewMode={viewMode}
        holeByHoleView={holeByHoleView}
        label={label}
        showYardage={showYardage}
        onToggleYardage={onToggleYardage}
      />
    </table>
  );
};

DetailsHoleTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
  holeByHoleView: PropTypes.string,
  label: PropTypes.string,
  showYardage: PropTypes.bool,
  onToggleYardage: PropTypes.func.isRequired,
};

export default DetailsHoleTable;
